import { Toolbar, Tabs, Tab, Box } from '@mui/material';
import { useRef, useState } from 'react';
import {
  ProjectContext,
  ProjectProvider,
  useProjectContext,
} from 'contexts/project.context';

import { ProjectTabDrawer } from 'drawers/ProjectTabDrawer';
import { Project } from 'store/api/models';
import { ProjectHeader } from 'components/project/ProjectHeader';
import { ProjectPlan } from 'components/project/ProjectPlan';
import { Workflow } from 'components/project/Workflow';
import { ProjectComponentProps } from 'components/Project';
import { ProjectInfoTab } from 'drawers/tabs/ProjectInfoTab';
import { AlertDialog } from '@centerpiece/components';

export interface TabbedTemplatePageProps {
  initialTab?: string;
}

export const TabbedTemplatePage = ({
  initialTab,
  ...project_props
}: ProjectComponentProps & TabbedTemplatePageProps) => {
  const {
    id,
    template,
    disabled,
    afterSave,
    preview,
    header,
    onBack,
    onLogoClick,
    exampleProject,
  } = project_props;
  const [value, setValue] = useState<string>(initialTab || 'project_plan');
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [openProjectInfo, setOpenProjectInfo] = useState<string>();
  const [openSpeedDial, setOpenSpeedDial] = useState<boolean>(false);
  const itemsRef = useRef({});
  return (
    <ProjectProvider
      id={id}
      template={template}
      disabled={disabled}
      afterSave={afterSave}
      itemsRef={itemsRef}
      preview={preview}
    >
      <ProjectContext.Consumer>
        {({
          id,
          project,
          template,
          refetchProject,
          alertDetails,
          setAlertDetails,
        }) => (
          <div style={{ overflowY: 'scroll', height: '100vh' }}>
            <ProjectHeader
              setOpenProjectInfo={setOpenProjectInfo}
              onBack={onBack}
              onLogoClick={onLogoClick}
              setOpenSpeedDial={setOpenSpeedDial}
              append={
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={value}
                    variant={'scrollable'}
                    onChange={(event, value) => handleChange(event, value)}
                    sx={{
                      width: '100%',
                      '& .MuiTabs-flexContainer': {
                        pl: 0,
                      },
                    }}
                  >
                    <Tab
                      key={'project_plan'}
                      label={'Project Plan'}
                      value={'project_plan'}
                    />
                    <Tab key={'info'} label={'Information'} value={'info'} />
                    {/* <Tab
                      key={'project_workflow'}
                      label={'Project Workflow'}
                      value={'project_workflow'}
                    /> */}
                  </Tabs>
                </Box>
              }
            />
            {openProjectInfo && (
              <ProjectTabDrawer
                template={template}
                exampleProject={exampleProject?.project as Project}
                open={!!openProjectInfo}
                initialTab={openProjectInfo || ''}
                id={id}
                archived={project.archived}
                onClose={() => {
                  setOpenProjectInfo(undefined);
                }}
                afterSave={() => refetchProject()}
              />
            )}
            {value === 'project_plan' && <ProjectPlan {...project_props} />}
            {value === 'info' && (
              <ProjectInfoTab
                {...project_props}
                afterSave={() => refetchProject()}
              />
            )}
            {value === 'project_workflow' && false && <Workflow />}
            <AlertDialog
              {...(alertDetails || {})}
              onClose={() => {
                setAlertDetails({ open: false });
              }}
            />
          </div>
        )}
      </ProjectContext.Consumer>
    </ProjectProvider>
  );
};
